const dropdowns = document.querySelectorAll('.am-contact__dropdown-menu');
const menu = document.querySelectorAll('.am-customer-service__menu');
const icon = document.querySelectorAll('.am-contact__dropdown-icon');
dropdowns.forEach((dropdown, index) => {
    let isHidden = true;
    dropdown.addEventListener('click', (event) => {
        event.stopPropagation();
        if (isHidden) {
            menu[index].style.display = 'block';
            icon[index].style.transform = 'rotate(180deg)';
        } else {
            menu[index].style.display = 'none';
            icon[index].style.transform = 'rotate(0deg)';
        }
        isHidden = !isHidden;
    });
});
document.body.addEventListener('click', () => {
    if (window.innerWidth > 750) return;

    menu.forEach((hidden, index) => {
        hidden.style.display = 'none';
        icon[index].style.transform = 'rotate(0deg)';
    });
});
menu.forEach((hidden) => {
    hidden.addEventListener('click', (event) => {
        event.stopPropagation();
    })
});

